/**
 * Place search for ops map — lat,lng parse + Open-Meteo geocoding (browser CORS).
 */

/** @returns {{ lat: number, lng: number, label: string } | null} */
export function parseLatLngPair(raw) {
  const s = String(raw || "").trim();
  const mComma = s.match(/^\s*(-?\d+(?:\.\d+)?)\s*[,，]\s*(-?\d+(?:\.\d+)?)\s*$/);
  if (mComma) {
    return _pairFromNums(mComma[1], mComma[2]);
  }
  const mSpace = s.match(/^\s*(-?\d+(?:\.\d+)?)\s+(-?\d+(?:\.\d+)?)\s*$/);
  if (mSpace) {
    return _pairFromNums(mSpace[1], mSpace[2]);
  }
  return null;
}

/** @returns {{ lat: number, lng: number, label: string } | null} */
function _pairFromNums(a, b) {
  const lat = Number(a);
  const lng = Number(b);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  if (Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;
  return { lat, lng, label: `${lat.toFixed(5)}, ${lng.toFixed(5)}` };
}

async function _fetchOpenMeteoOnce(q, lang) {
  const u = new URL("https://geocoding-api.open-meteo.com/v1/search");
  u.searchParams.set("name", q);
  u.searchParams.set("count", "10");
  u.searchParams.set("format", "json");
  if (lang) u.searchParams.set("language", lang);
  const r = await fetch(u.toString(), { credentials: "omit" });
  if (!r.ok) throw new Error(`geocode HTTP ${r.status}`);
  const j = await r.json().catch(() => ({}));
  const rows = Array.isArray(j.results) ? j.results : [];
  return rows;
}

function _rowToHit(row, fallbackQ) {
  const lat = Number(row.latitude);
  const lng = Number(row.longitude);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  const name = [row.name, row.admin1, row.country_code]
    .map((x) => String(x || "").trim())
    .filter(Boolean)
    .join(", ");
  return { lat, lng, label: name || fallbackQ };
}

/** @returns {Promise<{ lat: number, lng: number, label: string } | null>} */
export async function geocodeOpenMeteo(query) {
  const q = String(query || "").trim();
  if (!q) return null;
  const langs = ["en", "zh", "ms", "id", ""];
  const seen = new Set();
  for (const lang of langs) {
    const key = lang || "__default__";
    if (seen.has(key)) continue;
    seen.add(key);
    let rows;
    try {
      rows = await _fetchOpenMeteoOnce(q, lang);
    } catch (e) {
      throw e;
    }
    if (rows.length) {
      const hit = _rowToHit(rows[0], q);
      if (hit) return hit;
    }
  }
  return null;
}
